import React from 'react';
import BlockContent from '@sanity/block-content-to-react';
import richText from '../serializers/richText';
import { Link } from 'gatsby';
import Slider from 'react-slick';



const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 10000,
};

export default ({ slides = [] }) => (
  <React.Fragment>
    {slides && slides.length > 0 && (
      <section className="home-carousel bb--dark-brown">
        <Slider {...settings}>
          {slides.map(slide => {
            return (
              <div key={slide._key} className="home-carousel__slide pr">
                <picture className="home-carousel__slide-img">
                  <source
                    srcSet={`${slide.image.url}?w=2000&auto=format&q=100`}
                    media="(min-width: 1400px)"
                  />
                  <source
                    srcSet={`${slide.image.url}?w=1500&auto=format&q=100`}
                    media="(min-width: 1000px)"
                  />
                  <source
                    srcSet={`${slide.image.url}?w=1200&auto=format&q=100`}
                    media="(min-width: 600px)"
                  />
                  <img
                    alt={slide.title}
                    src={`${slide.image.url}?w=1000&auto=format&q=100`}
                  />
                </picture>

                {slide.description && slide.title && (
                  <aside className="home-carousel__slide-info p2 pt5 pb5 p5--lg">
                    <p className="serif--md serif--lg--lg pb2 ">
                      {slide.title}
                    </p>
                    <div className="sans--sm sans--md--md pb2 pb5--lg">
                      <BlockContent
                        blocks={slide.description}
                        serializers={richText}
                      />
                    </div>
                    {slide.link && (
                      <Link
                        className="serif--sm serif--md--md link--underline"
                        to={slide.link.url}
                      >
                        {slide.link.title}
                      </Link>
                    )}
                  </aside>
                )}
              </div>
            );
          })}
        </Slider>
      </section>
    )}
  </React.Fragment>
);
